import { useEffect, useState, useCallback } from 'react';
import api from '../../../../services/api';

export function useInstallationTeams() {
  const [teams, setTeams] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchTeams = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);
      const res = await api.get('/installation-teams');
      const payload = res?.data;
      const list = Array.isArray(payload)
        ? payload
        : Array.isArray(payload?.data)
        ? payload.data
        : Array.isArray(payload?.items)
        ? payload.items
        : Array.isArray(payload?.result)
        ? payload.result
        : Array.isArray(payload?.installationTeams)
        ? payload.installationTeams
        : Array.isArray(payload?.installation_teams)
        ? payload.installation_teams
        : [];
      setTeams(list);
    } catch (e) {
      setError(e);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { fetchTeams(); }, [fetchTeams]);

  return { teams, loading, error, refresh: fetchTeams };
}
